import { axiosClient as axios } from './axiosClient';

import {
  BillingAddressResultViewModel,
  BillingAddressTableResultViewModel,
  BillingAddressViewModel,
} from '@models/BillingAddress';
import {
  failureResult,
  ResultViewModel,
  successResult,
} from '@models/common/ResultViewModel';
import { handleAxiosError } from '@utils/axiosErrorHandler';
import { getDataUrl } from '@utils/dataUrls';
import { api } from 'src/config/apiEndpoints';

export const BillingAddressService = {
  create: async function (
    billing: BillingAddressViewModel
  ): Promise<BillingAddressResultViewModel | ResultViewModel> {
    const createUrl = `${api.BASE_URL}${api.BILLING_ADDRESSES_ENDPOINT}`;

    try {
      const response = await axios.post(createUrl, billing);
      return response.data as BillingAddressResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getList: async function (
    page?: number,
    pageSize?: number,
    searchFields?: string,
    search?: string,
    filters?: string,
    sortBy?: string,
    sortDirection?: string
  ): Promise<BillingAddressTableResultViewModel | ResultViewModel> {
    let dataUrl = getDataUrl(
      api.BASE_URL,
      api.BILLING_ADDRESSES_ENDPOINT,
      page,
      pageSize,
      searchFields,
      search,
      sortBy,
      sortDirection
    );
    if (filters) {
      dataUrl = dataUrl + filters;
    }

    try {
      const response = await axios.get(dataUrl);
      return response.data as BillingAddressTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getById: async function (
    id: number
  ): Promise<BillingAddressResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.BILLING_ADDRESSES_ENDPOINT}/${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as BillingAddressResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  update: async function (
    id: number,
    billing: BillingAddressViewModel
  ): Promise<ResultViewModel> {
    const updateUrl = `${api.BASE_URL}${api.BILLING_ADDRESSES_ENDPOINT}/${id}`;

    try {
      const response = await axios.put(updateUrl, billing);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  delete: async function (id: number): Promise<ResultViewModel> {
    const deleteURL = `${api.BASE_URL}${api.BILLING_ADDRESSES_ENDPOINT}/${id}`;

    try {
      const response = await axios.delete(deleteURL);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
};
